export enum EValidationIssueSeverity {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}
